<script>
export let humidity;
</script>

<div>
    Humidity: {humidity} %
</div>